<template>
  <div>
    <b-card no-body class="mt-3" type="dark" bg-variant="light">
      <b-col class="ml--2">
        <h3 class="mt-1 ml-1">Grundkosten</h3>
      </b-col>
    </b-card>

    <!-- Porto -->
    <InputCard
      :input="{
        headline: 'Porto',
        row1: {
          text: 'Porto/ Einsendeart/ Stk.',
          disabledCheck: false,
          icon: 'clock-history',
          vuexModule: 'Grundkosten',
          stateObj: 'porto',
          value: 'kosten',
          mutationName: 'Grundkosten/updatePorto',
          rowFormat: 'currency'
        },
        row2: {
          text: 'Anzahl der Pakete',
          disabledCheck: false,
          icon: 'box',
          vuexModule: 'Kostentraegermanagment',
          stateObj: 'erstellung',
          value: 'rechnungen',
          mutationName: 'Kostentraegermanagment/updateRechnungen'
        },
        row3: {
          text: '',
          disabledCheck: true,
          icon: 'clock',
          value: 'Sidebar/monatlicheBelege',
          mutationName: ''
        },
        row4: {
          text: 'Gesamtkosten',
          disabledCheck: true,
          icon: 'cash-stack',
          value: 'Grundkosten/gesamtKostenPorto',
          mutationName: ''
        },
        row5: {
          text: 'Kosten pro Beleg',
          disabledCheck: true,
          icon: 'cash',
          value: 'Grundkosten/kostenBelegPorto',
          mutationName: ''
        }
      }"
    />

    <!-- Papier -->
    <InputCard
      :input="{
        headline: 'Papier',
        row1: {
          text: 'Papierkarton (500 Papier)',
          disabledCheck: false,
          icon: 'files',
          vuexModule: 'Grundkosten',
          stateObj: 'papier',
          value: 'kosten',
          mutationName: 'Grundkosten/updatePapierkosten',
          rowFormat: 'currency'
        },
        row2: {
          text: 'Einzelstück',
          disabledCheck: true,
          icon: 'file',
          vuexModule: 'Grundkosten',
          stateObj: 'papier',
          value: 'kostenEinzeln',
          mutationName: 'Grundkosten/updatePapierkostenEinzeln',
          rowFormat: 'currency'
        },
        row3: {
          text: 'Belege',
          disabledCheck: true,
          icon: 'files',
          value: 'Sidebar/monatlicheBelege',
          mutationName: ''
        },
        row4: {
          text: 'Gesamtkosten',
          disabledCheck: true,
          icon: 'cash-stack',
          value: 'Grundkosten/gesamtKostenPapier',
          mutationName: ''
        },
        row5: {
          text: 'Kosten pro Beleg',
          disabledCheck: true,
          icon: 'cash',
          value: 'Grundkosten/kostenBelegPapier',
          mutationName: ''
        }
      }"
    />

    <!-- Druck -->
    <InputCard
      :input="{
        headline: 'Druck',
        row1: {
          text: 'Tonerkosten stk.',
          disabledCheck: false,
          icon: 'printer',
          vuexModule: 'Grundkosten',
          stateObj: 'druck',
          value: 'toner',
          mutationName: 'Grundkosten/updateToner',
          rowFormat: 'currency'
        },
        row2: {
          text: 'Gesamtbelege 12 Monate',
          disabledCheck: true,
          icon: 'files',
          vuexModule: 'Sidebar',
          stateObj: 'monatlich',
          value: 'jaehrlicheBelege',
          mutationName: ''
        },
        row3: {
          text: 'Fassung 2300 / Gesamtbelege',
          disabledCheck: true,
          icon: 'files',
          value: 'Grundkosten/gesamtBelegeFassung',
          mutationName: ''
        },
        row4: {
          text: 'Gesamtkosten',
          disabledCheck: true,
          icon: 'cash-stack',
          value: 'Grundkosten/gesamtKostenDruck',
          mutationName: ''
        },
        row5: {
          text: 'Kosten pro Beleg',
          disabledCheck: true,
          icon: 'cash',
          value: 'Grundkosten/kostenBelegDruck',
          mutationName: ''
        }
      }"
    />
  </div>
</template>

<script>
import InputCard from "@/components/InputCard.vue";
export default {
  name: "Grundkosten",
  components: {
    InputCard
  }
};
</script>
